import { useState } from "react";
import api from "../lib/api";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { toast } from "sonner";
import { downloadBlob } from "./FollowupFields";
import { Stethoscope, CheckCircle2, XCircle, Download, Loader2 } from "lucide-react";

export function ClearancePanel({ c, onUpdated }) {
  const [specialist, setSpecialist] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState("");
  const record = async (outcome) => {
    setBusy(outcome);
    try {
      const { data } = await api.put(`/cases/${c.id}/clearance`, { outcome, specialist, note });
      onUpdated(data);
      toast.success(outcome === "approved" ? "Approval recorded — decision updated to PROCEED" : "Recorded — procedure deferred");
    } catch (err) {
      toast.error(typeof err.response?.data?.detail === "string" ? err.response.data.detail : "Could not record the response");
    } finally {
      setBusy("");
    }
  };
  const who = (c.decision?.final_decision?.consult || []).map((x) => x.specialist).join(" · ");
  return (
    <div data-testid="clearance-panel" className="mt-5 rounded-xl border-2 border-orange-300 bg-orange-50 p-6">
      <h4 className="font-heading font-semibold text-orange-900 flex items-center gap-2"><Stethoscope className="w-4 h-4" /> Awaiting specialist approval</h4>
      <p className="text-sm text-orange-800 mt-1">Send the report to: <b>{who}</b>. When the reply arrives, record it below — the decision updates automatically.</p>
      <Button size="sm" variant="outline" className="mt-3 bg-white" data-testid="clearance-report-pdf"
        onClick={() => downloadBlob(api, `/cases/${c.id}/pdf`, `referral_${c.id}.pdf`).catch(() => toast.error("Could not generate PDF"))}>
        <Download className="w-4 h-4 mr-1.5" /> Consultation report PDF
      </Button>
      <div className="grid sm:grid-cols-2 gap-3 mt-4">
        <Input data-testid="clearance-specialist" value={specialist} onChange={(e) => setSpecialist(e.target.value)} placeholder="Specialist name (optional)" className="bg-white" />
        <Textarea data-testid="clearance-note" value={note} onChange={(e) => setNote(e.target.value)} placeholder="Specialist's advice / conditions (optional)" rows={1} className="bg-white" />
      </div>
      <div className="flex flex-wrap gap-3 mt-4">
        <Button onClick={() => record("approved")} disabled={!!busy} data-testid="clearance-approve-btn" className="bg-emerald-600 hover:bg-emerald-700">
          {busy === "approved" ? <Loader2 className="w-4 h-4 animate-spin" /> : <><CheckCircle2 className="w-4 h-4 mr-2" /> Approval received</>}
        </Button>
        <Button onClick={() => record("declined")} disabled={!!busy} variant="outline" data-testid="clearance-decline-btn" className="border-red-300 text-red-700 bg-white hover:bg-red-50">
          {busy === "declined" ? <Loader2 className="w-4 h-4 animate-spin" /> : <><XCircle className="w-4 h-4 mr-2" /> Not approved</>}
        </Button>
      </div>
    </div>
  );
}
